var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChecked = function SvgChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8405 5.44714C16.1458 5.72703 16.1664 6.20146 15.8865 6.5068L8.55319 14.5068C8.41496 14.6576 8.22113 14.7454 8.01662 14.7498C7.8121 14.7543 7.61464 14.675 7.47 14.5303L4.13666 11.197C3.84377 10.9041 3.84377 10.4292 4.13666 10.1363C4.42956 9.84345 4.90443 9.84345 5.19732 10.1363L7.97677 12.9158L14.7808 5.49321C15.0607 5.18787 15.5351 5.16724 15.8405 5.44714Z",
    fill: "white"
  })));
};
export default SvgChecked;